import { Injectable } from '@angular/core';
import { MatSnackBarConfig, MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class ErrorService {

  // TODO: #MUI We are moving the application away from Angular Material, so this service will need to be updated to display errors without Angular Material

  private defaultConfig: MatSnackBarConfig = {
    duration: 10000,
    panelClass: ['bg']
  }

  constructor(
    private snackBar: MatSnackBar
  ) { }

  public open(message: string, action?: string, config: MatSnackBarConfig = this.defaultConfig) {
    this.snackBar.open(message, action, config);
  }
}
